'use client'

import Image from 'next/image'
import { useState } from 'react'

const TeamCard: React.FC<{ item }> = ({ item }) => {
  const { name, title, email, photo } = item
  const [showEmail, setShowEmail] = useState(false)

  const mainImage = photo;

  const emailUser = email.split('@')[0]
  const emailDomain = email.split('@')[1]
  const titles = title.split('\n');

  return (
      <div>
        <div className='relative rounded-2xl border border-dark/10 dark:border-white/10 group hover:shadow-3xl duration-300 dark:hover:shadow-white/20'>
          <div className='overflow-hidden rounded-t-2xl'>
            {mainImage && (
                <Image
                    src={mainImage}
                    alt={name}
                    width={403}
                    height={403}
                    className='w-full rounded-t-2xl grayscale group-hover:brightness-50 group-hover:scale-125 transition duration-300 delay-75'
                    unoptimized={true}
                />
            )}
          </div>
          <div className='p-6'>
            <div className='flex flex-col mobile:flex-row gap-5 mobile:gap-0 justify-between mb-6'>
              <div>
                <h3 className='text-xl font-medium text-black dark:text-white duration-300 group-hover:text-primary'>
                    {name}
                  </h3>
                {titles.map((line: string, index: number) => (
                    <p key={index} style={{ fontSize: "18px" }} className='text-base text-black/60 dark:text-white/50'>
                      {line}
                    </p>
                ))}
              </div>
            </div>
            <div className='flex'>
              <div
                  className='flex flex-col gap-2 border-e border-black/10 dark:border-white/20 pr-2 xs:pr-4 mobile:pr-8'
                  onMouseEnter={() => setShowEmail(true)}
                  onMouseLeave={() => setShowEmail(false)}
              >
                <p className='text-sm mobile:text-base font-normal text-black dark:text-white select-none'>
                  {showEmail ? (
                      <a href={`mailto:${emailUser}@${emailDomain}`}>
                        {emailUser}@{emailDomain}
                      </a>
                  ) : (
                      <span className="opacity-50 italic">İletişim için tıklayın</span>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default TeamCard
